"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Canvas = void 0;
const PIXI = __importStar(require("pixi.js"));
const module_abstract_1 = require("@kennethgomez/module/module.abstract");
const animations_1 = require("./animations/animations");
const ticker_1 = require("./ticker/ticker");
const space_1 = require("./space/space");
class Canvas extends module_abstract_1.Module {
    static CANVAS_BACKGROUND = 0x101010;
    _app;
    _viewCanvas;
    constructor() {
        super([
            new ticker_1.Ticker(),
            new space_1.Space(),
            new animations_1.Animations(),
        ]);
        this._app = new PIXI.Application({
            width: window.innerWidth,
            height: window.innerHeight,
            backgroundColor: Canvas.CANVAS_BACKGROUND,
        });
        this._viewCanvas = this.viewCanvas;
    }
    onInit() {
        this._viewCanvas.appendChild(this._app.view);
        this._app.ticker.add(this.ticker.update, this.ticker);
        this._app.stage.addChild(this.space.container);
    }
    get viewCanvas() {
        if (this._viewCanvas) {
            return this._viewCanvas;
        }
        const view = document.getElementById('background-canvas');
        if (!view) {
            throw new Error('Canvas element does not exist on document');
        }
        return view;
    }
    get ticker() {
        return this.getSubmodule(ticker_1.Ticker);
    }
    get space() {
        return this.getSubmodule(space_1.Space);
    }
    get animations() {
        return this.getSubmodule(animations_1.Animations);
    }
    get app() {
        return this._app;
    }
}
exports.Canvas = Canvas;
